function delete_cookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
let timestamp=Date.now();

document.addEventListener("DOMContentLoaded",function () {
    // code for property page starts
var pagecrrnturl =  window.location.href;
  if (pagecrrnturl.indexOf("pages/new-property-page") > -1){
          var totalCookiesNow =  getCookie('itemsArr')
    if(totalCookiesNow == ''){
      window.location.href = "/";
    }
    var currntProduct = getCookie("currentProduct");
    var  currntProductPrice = getCookie("currentProductPrice"); 
    var currntProductType = getCookie("currentProductType"); 
    var currntPageType = getCookie("currentPageType");
    var currntProductColor =  getCookie("currntProductColor");
    var currntProductQauntity =  getCookie("currntProductQauntity");
    var pintingPricesAddon =  getCookie("pintingPricesAddon");
    var ProductPack =  getCookie("ProductPack");
    var totalPricingAdd = currntProductQauntity * ProductPack;
    var firstTierQuantity = getCookie("FirstTierQuantity");
    var secondTierQuantity = getCookie("SecondTierQuantity");
    var thirdTierQuantity = getCookie("ThirdTierQuantity");
    var firstTierDiscount = getCookie("FirstTierDiscount");
    var secondTierDiscount = getCookie("SecondTierDiscount");
    var thirdTierDiscount = getCookie("ThirdTierDiscount");
   var  CurrProductHandle = getCookie("ProductHandle");
    if(pintingPricesAddon == '16x24'){
      $("#custom-image-printing-images-jtpl").addClass("not-sqare-size-jtpl")
    }
    if (currntPageType == 'productPage'){
       $("[data-varinat-color='"+currntProductColor+"']").trigger( "click" );
      $(".color-variants li").hide();
    }
    $("[data-printing-title="+pintingPricesAddon+"]").attr( "selected","selected" );
    $(".property-marking-page-title-jtpl .product-title").html(currntProduct);
    $(".product-price-show .inner_price").html(currntProductPrice+currntProductType);
    
      var selectedPrnting = $('.printing-pricing-jtpl').find(":selected").attr("data-printing-id");
     var selectedPrntingPrice = $('.printing-pricing-jtpl').find(":selected").attr("data-printing-price");
     var currntqantity1 = $('.new-custom-qty__wrapper').find("#product-quantity-input2").attr("value");
      var currntqantity = parseInt(currntqantity1);
    var selectedPrntingPrice = parseFloat(selectedPrntingPrice);
    var TotalPrntingPrice = selectedPrntingPrice * totalPricingAdd;
    var packedPricng = ProductPack * selectedPrntingPrice;
       var packedPricng = parseFloat(packedPricng).toFixed(2);
    setTimeout(function(){
       var main_price = $(".all-property-products-details .price-to-be-updated").text();
   console.log(main_price+"===="+packedPricng);
    var total_price_per_pack = parseFloat(main_price) + parseFloat(packedPricng);
      total_price_per_pack =total_price_per_pack.toFixed(2);
      $(".prop-price").append(" + $"+packedPricng+"/per Pack ");
        
      $(".printing-pricing").append(" +Printing Price $"+TotalPrntingPrice);
    $(".product-price-show .inner_price").html("$"+total_price_per_pack);
    $.ajax({
     url:'https://www.microfiberwholesale.com/products/'+CurrProductHandle+'?view=ajax-reviews',
     type:'GET',
     success: function(data){
       $('#ReviewsWidget').html(data);
       $('#ReviewsWidget').hide();
       $('#ReviewsWidget main').hide()
       $('#ReviewsWidget footer').hide()
       $('#ReviewsWidget #header-group').hide()
       $('#ReviewsWidget').show();
       const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        console.log("doc---",doc);
        $("#ReviewsWidget").html($("#ReviewsWidget").find("#ReviewsWidget"))
        
       }
});
     },300)

      var cookArr = getCookie("itemsArr");
 
  if(cookArr){
    console.log('cookArr===',cookArr);
    
      var cookArr = getCookie('itemsArr').split('*');
      $.each(cookArr, function (key, value) {
        var currentData = this;
        var cook__data__val = value.split('~');
        var variant_id_2 = cook__data__val[0];
        var pro_title_2 = cook__data__val[1];
        var pro_price_2 = cook__data__val[2];
        var pro_price_2 = parseFloat(pro_price_2).toFixed(2);
        var pro_qty_2 = cook__data__val[3];
        var pro_image_2 = cook__data__val[4];
        var pro_varient_2 = cook__data__val[5];
        var current_single_price = cook__data__val[6];
        var pro_price_2 = parseFloat(pro_price_2) + parseFloat(TotalPrntingPrice);
        var pro_price_2  = parseFloat(pro_price_2).toFixed(2);
        if(pro_varient_2 != 'undefined'){
          pro_varient_2 = pro_varient_2;
        }
        else{
          pro_varient_2 = "";
        }
        var pro_qty_2 = parseInt(pro_qty_2);
          var firstTierQuantity = getCookie("FirstTierQuantity");
    var secondTierQuantity = getCookie("SecondTierQuantity");
    var thirdTierQuantity = getCookie("ThirdTierQuantity");
    var firstTierDiscount = getCookie("FirstTierDiscount");
    var secondTierDiscount = getCookie("SecondTierDiscount");
    var thirdTierDiscount = getCookie("ThirdTierDiscount");
    var taggedCustomerPrice = getCookie("taggedCustomer");
    var current_single_discount=0;
    var current_single_discount=current_single_price;
    console.log("current_single_price====",current_single_price);
    
        if(firstTierQuantity){
        var firstTierQuantity = parseInt(firstTierQuantity);
        if (pro_qty_2 >= firstTierQuantity ){
          var current_single_discount = firstTierDiscount;
        }
        }
        if(secondTierQuantity){
          var secondTierQuantity = parseInt(secondTierQuantity);
        if (pro_qty_2 >= secondTierQuantity ){
          
          var current_single_discount = secondTierDiscount;
        }
        }
        if(thirdTierQuantity){
        var thirdTierQuantity = parseInt(thirdTierQuantity);
        if (pro_qty_2 >= thirdTierQuantity ){
          var current_single_discount = thirdTierDiscount;
        }
        }
        if(taggedCustomerPrice){
          var current_single_discount = taggedCustomerPrice;
        }
        console.log();
        
            // var new_price = parseFloat(current_single_price);
            var new_price = parseFloat(current_single_discount);
            var final_price = parseFloat(pro_qty_2*new_price).toFixed(2);
            var finalPrintingPriceTotal =  parseFloat(pro_qty_2*packedPricng).toFixed(2);
            var FinalSubtotal = parseFloat(finalPrintingPriceTotal)+parseFloat(final_price);
             var  FinalSubtotal = parseFloat(FinalSubtotal).toFixed(2);
             console.log("cook__data__val===",cook__data__val);
             console.log("finalPrintingPriceTotal---",finalPrintingPriceTotal);
             
             
        if(cook__data__val != ''){
          $(".all-property-products-details").append("<div class='prop-pro-outer-wp product_selected_true' data_pro_id="+variant_id_2+" data_pro_price="+current_single_discount+" data_final_price="+pro_price_2+">  <div class='prop-image-cell'><img src="+pro_image_2+"/></div>  <div class='prop-title-price-outer'><h2>"+pro_title_2+"</h2> <legend class='option-header prop-varient-select'>"+pro_varient_2+"</legend> <span class='prop-price-2 th_do_item_price money'></span><span class='prop-price th_do_item_price money'>"+"<span class='original-price-jtpl cart-item--sale-price'>$"+current_single_price+"</span>$<span class='price-to-be-updated'>"+current_single_discount+"</span></span> </div>   <div class='js-qty__wrapper new-custom-qty__wrapper'> <div class='js-qty-wrapper'> <button type='button' class='js-qty__adjust2 product-js-qty__adjust2 js-qty__adjust--minus2 qty_selected select_minus'>-</button> <input type='text' id='product-quantity-input2' class='js-qty__num2 qty-inner-select-val2' value="+pro_qty_2+">  <button type='button' class='js-qty__adjust2 product-js-qty__adjust2 js-qty__adjust--plus2 qty_selected select_plus' id='qty__adjust--plus-id2'>+</button></div><div class='totalPrinting-marking'><span class='product-marking-total'>Total: <b>$"+FinalSubtotal+"</b></span><span class='printing-pricing'></span></div> </div> <div class='prop-checked-icon image_show'> <img src='https://cdn.shopify.com/s/files/1/0280/4006/9155/files/check_icon_2x-8.png?v=1714363809'/><span class='image_round jtpl_hidden'></span> </div></div>");
        }
                 return false;
      });
  }
    
  }
  // code for property page ends
  $(document).on('click','.prop-pro-outer-wp .qty_selected',function(e){
      e.preventDefault();
    var firstTierQuantity = getCookie("FirstTierQuantity");
    var secondTierQuantity = getCookie("SecondTierQuantity");
    var thirdTierQuantity = getCookie("ThirdTierQuantity");
    var firstTierDiscount = getCookie("FirstTierDiscount");
    var secondTierDiscount = getCookie("SecondTierDiscount");
    var thirdTierDiscount = getCookie("ThirdTierDiscount");
    var taggedCustomerPrice = getCookie("taggedCustomer");
    var currentProductPrice = Number(getCookie("currentProductPrice").replace("$",""));
        var qty_qty = parseFloat($(this).siblings('.qty-inner-select-val2').val());
          if($(this).hasClass('select_plus')){
            var new_qty_qty = parseFloat((qty_qty+1));
        if(firstTierQuantity){
        var firstTierQuantity = parseInt(firstTierQuantity);
        if (new_qty_qty >= firstTierQuantity ){
          var current_single_discount = firstTierDiscount;
        }
        }
        if(secondTierQuantity){
          var secondTierQuantity = parseInt(secondTierQuantity);
        if (new_qty_qty >= secondTierQuantity ){
          
          var current_single_discount = secondTierDiscount;
        }
        }
        if(thirdTierQuantity){
        var thirdTierQuantity = parseInt(thirdTierQuantity);
        if (new_qty_qty >= thirdTierQuantity ){
          var current_single_discount = thirdTierDiscount;
        }
        }
        if(taggedCustomerPrice){
          var current_single_discount = taggedCustomerPrice;
        }
            // var new_price = parseFloat(currentProductPrice);
            var new_price = parseFloat(current_single_discount);
            var final_price = parseFloat(new_qty_qty*new_price).toFixed(2);
            $(this).siblings('.qty-inner-select-val2').val(new_qty_qty);
            var finalPrintingPriceTotal =  parseFloat(new_qty_qty*packedPricng).toFixed(2);
            var FinalSubtotal = parseFloat(finalPrintingPriceTotal)+parseFloat(final_price);
             var  FinalSubtotal = parseFloat(FinalSubtotal).toFixed(2);
            $(".price-to-be-updated").html(new_price);
            $(this).parents('.prop-pro-outer-wp').find('.product-marking-total').html("Total: <b>$"+FinalSubtotal+"</b>");
            $(this).parents('.prop-pro-outer-wp').find('.printing-pricing').html("+Printing Price $"+finalPrintingPriceTotal); 
          }
          else{
              var new_qty_qty = parseFloat((qty_qty-1));
        if(qty_qty > 1){
        if(firstTierQuantity){
        var firstTierQuantity = parseInt(firstTierQuantity);
        if (new_qty_qty >= firstTierQuantity ){
          var current_single_discount = firstTierDiscount;
        }
        }
        if(secondTierQuantity){
          var secondTierQuantity = parseInt(secondTierQuantity);
        if (new_qty_qty >= secondTierQuantity ){
          
          var current_single_discount = secondTierDiscount;
        }
        }
        if(thirdTierQuantity){
        var thirdTierQuantity = parseInt(thirdTierQuantity);
        if (new_qty_qty >= thirdTierQuantity ){
          var current_single_discount = thirdTierDiscount;
        }
        }
        if(taggedCustomerPrice){
          var current_single_discount = taggedCustomerPrice;
        }
              var new_price = parseFloat(current_single_discount);
              var final_price = parseFloat(new_qty_qty*new_price).toFixed(2);
              var finalPrintingPriceTotal =  parseFloat(new_qty_qty*packedPricng).toFixed(2);
              var FinalSubtotal = parseFloat(finalPrintingPriceTotal)+parseFloat(final_price);
              var  FinalSubtotal = parseFloat(FinalSubtotal).toFixed(2);
              $(".price-to-be-updated").html(new_price);
              $(this).siblings('.qty-inner-select-val2').val(new_qty_qty);
            $(this).parents('.prop-pro-outer-wp').find('.product-marking-total').html("Total: <b>$"+FinalSubtotal+"</b>");
            $(this).parents('.prop-pro-outer-wp').find('.printing-pricing').html("+Printing Price $"+finalPrintingPriceTotal);
            console.log(new_qty_qty);
              
            }
          }
    });
});

$('body').on('click', '.property-popup-jtpl', function(e){
    e.preventDefault();
  $("#proof-popup").addClass("second-button-show");
  $("body").addClass("button-popup-enable");
});

$('body').on('click', '#proof-popup .close-icon-cell', function(e){
    e.preventDefault();
  $("#proof-popup").removeClass("second-button-show");
  $("body").removeClass("button-popup-enable");
});

function callback(value) {
    if (value) {
        alert("Confirmed");
    } else {
        alert("Rejected");
    }
}
// preventing page from redirecting
    $("html").on("dragover", function(e) {
         e.preventDefault();
         e.stopPropagation();
         //$("h1").text("Drag here");
    });

    $("html").on("drop", function(e) { e.preventDefault(); e.stopPropagation(); });
   
    // Select
    $('#file-drag').click(function(){
        // e.preventDefault();
        $('#upload_logo').trigger('click');
      setTimeout(function(){
         // if($('#upload_logo').val() != ''){
          $('.uploaded-image-container').css('display', 'flex');
      // }
      }, 1000);
      
    });
    // Drag enter
    $('.upload-container').on('dragenter', function (e) {
         e.stopPropagation();
         e.preventDefault();
         //$("h1").text("Drop");
    });

    // Drag over
    $('.upload-container').on('dragover', function (e) {
         e.stopPropagation();
         e.preventDefault();
        // $("h1").text("Drop");
    });

    // Drop
    $('.upload-container').on('drop', function (e) {
         e.stopPropagation();
         e.preventDefault();

        // $("h1").text("Upload");
       console.log(e);
      console.log(e.originalEvent.dataTransfer.files);
         var file = e.originalEvent.dataTransfer.files;
         var fd = new FormData();

         fd.append('file', file[0]);
      
         //openFile(e);
      document.querySelector( "#upload_logo" ).files = e.originalEvent.dataTransfer.files;
      console.log("Here---updated");
      $("#upload_logo").trigger("change");
      // if($('#upload_logo').val() != ''){
      //     $('.uploaded-image-container').css('display', 'flex');
      // }
    });
// Logo Size Range
var range = document.getElementById('logo_width'),
  rangeV = document.getElementById('rangeV'),
  setValue = ()=>{
    var newValue = Number( (range.value - range.min) * 100 / (range.max - range.min) ),
      newPosition = 10 - (newValue * 0.2);
    rangeV.innerHTML = `<span>${range.value}</span>`;
    rangeV.style.left = `calc(${newValue}% + (${newPosition}px))`;
    $('.custom-image-printing-images-jtpl .outer-main-jtpl-sct img').css('width', $("#logo_width").val());
    var logo_width_val = $("#logo_width").val()
    $('.logo_width').attr("value", logo_width_val)
    
  };
document.addEventListener("DOMContentLoaded", setValue);
range.addEventListener('input', setValue);
$('body').on('change', '#upload_logo', function(e){
    e.preventDefault();
   // var img = "";
  //  $(".image-upload-logo").html(img);
    openFile(e);
   var uploaded_img_title = $(this).val();
  var split_uploaded_img_title = uploaded_img_title.split('\\');
  $('.uploaded-image-title').text(split_uploaded_img_title[split_uploaded_img_title.length - 1]);
  });

var openFile = function(file) {
  console.log(file);
   $(".main-loader-div-cstm").attr("style","display:flex !important");
  
  var input = file.target;
  var reader = new FileReader();
   $(".error-message").html("");
   var validExtensions = ['png','jpg','jpeg']; //array of valid extensions
        var fileName = input.files[0].name;
        var fileNameExt = fileName.substr(fileName.lastIndexOf('.') + 1);
        // if ($.inArray(fileNameExt, validExtensions) == -1) {
          //   input.type = ''
          //   input.type = 'file'
          //   $('#image-upload-logo').attr('src',"");
          //  $(".error-message").html("Only png file types are accepted");
          // $(".main-loader-div-cstm").attr("style","display:none !important");
          // return false;
          
        // }else{
  reader.onload = function(){
    var dataURL = reader.result;
    $("#image-upload-logo").html('');
    $("#image-upload-logo-border").html('');
    var output = document.getElementById('image-upload-logo');
    var output1 = document.getElementById('image-upload-logo-border');

    
   const formData = new FormData();
formData.append('size', 'auto');
formData.append('image_file', input.files[0]);
   
 $.ajax({
   method: 'post',
  url: 'https://jeronone.com/test-server/boski/microfiber-custom-print/api1.php',
  data: formData,
  contentType: false,
   cache: false,
   processData:false,  
   async : false,
   success: function(response)
      {    
        dataURL = response;
        console.log(response);
             if(response.trim() != 'error'){
    $('.uploaded-image-image').html("<img src='" + dataURL +"' width='100%' height='100%' />");
    $('.extra-jtpl-properties').html("<img src='" + dataURL +"' width='100%' height='100%' />");
    $('.extra-jtpl-properties').show();          
       }else{
       $(".uploaded-image-delete-button").trigger("click");
               $('.uploaded-image-image').html(""); 
       }
      },
     error: function(error) 
      {
        console.log(error);
        // return false;
         alert('This logo is not supported!');
      }          
    });
// 

/* end ajax request to remove the bg */
  if(dataURL.trim() != 'error'){   
var len = 70;
    var html ='';
    var drag_logo ='';
    // var html1 ='';
    for(var i=0; i<len;i++){
      
      if (i % 2 === 0) { 
        var cls = "grid-even";
        /* we are even */ 
      }else { 
        var cls = "grid-odd";
        /* we are odd */ 
      }
      var drag_logo ="<img src='" + dataURL +"' class='drag_logo' id='drag-logo" + i+"' />";
      html += "<img src='" + dataURL +"' class='"+cls+"' id='img-random" + i+"' />";
     // html1 += "<img src='" + dataURL +"' class='"+cls+"' id='img-random-" + i+"' />";
    }
    output.innerHTML = html;
    // output1.innerHTML = html1;
     $('.custom-image-printing-images-jtpl .outer-main-jtpl-sct img').css('width', $("#logo_width").val());
    var logo_width_val = $("#logo_width").val()
    $('.logo_width').attr("value", logo_width_val)
   $(".file-drag").html(drag_logo);
     $(".main-loader-div-cstm").attr("style","display:none !important");
   setTimeout(function(){
   dataURLtoFile(dataURL,'upload_logo.png');
   },200);
  }else{
    
     $(".uploaded-image-delete-button").trigger("click");
    $(".main-loader-div-cstm").attr("style","display:none !important");
     alert("This logo is not supported");
   
    
  }
  };
  reader.readAsDataURL(input.files[0]);
        // }
};

function dataURLtoFile(dataurl, filename) {
     html2canvas(document.querySelector(".extra-jtpl-properties")).then(canvas => {
       canvas.style.width ="1000px";
       canvas.style.height ="1000px";
       
        document.body.appendChild(canvas);
       var image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
   console.log("image file : "+image);
         canvas.toBlob( (blob) => {
           
          // const file = new File( [ blob ], filename );
          //  console.log(file);
          // const dT = new DataTransfer();
          //   console.log(dT);
          // dT.items.add( file );
          //   console.log(dT.files);
          const file = new File( [ blob ], "logo.png" );
          const dT = new DataTransfer();
          dT.items.add( file );
            console.log(dT.files);
            document.querySelector("#properties_logo").files = dT.files;
           document.querySelector("#image_logo_checkout").innerHTML = "<img src='"+ image +"' class='image_logo_checkout'/>";
           $('.extra-jtpl-properties').hide();   
          });    
      
    });
}

function toDataUrl(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}

 function uploadImage(){
   $(".main-loader-div-cstm").attr("style","display:flex !important");
       html2canvas(document.querySelector("#custom-image-printing-images-jtpl")).then(canvas => {
       canvas.style.width ="400px";
       canvas.style.height ="400px";
       
        document.body.appendChild(canvas);
       var download = document.getElementById("downloadimage");
        var image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
   
         canvas.toBlob( (blob) => {
          const file = new File( [ blob ], "image-with-border.png" );
          const dT = new DataTransfer();
          dT.items.add( file );
            console.log(dT.files);
          document.querySelector( "#image-with-border" ).files = dT.files;
            // $(".personalization-submit").submit();
            // document.querySelector( "#backCapturedVal" ).value = dataUrl;
        } );    
        //download.setAttribute("href", image);
       //    download.click();
       //downloadPNG();
    });

      
    // html2canvas(document.querySelector("#custom-image-printing-images-jtpl-without-border")).then(canvas => {
    //    canvas.style.width ="400px";
    //    canvas.style.height ="400px";
    //    canvas.allowTainted = true;
    //   document.body.appendChild(canvas);
    //   var download = document.getElementById("downloadimagewithoutborder");
    //   var image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
    //     canvas.toBlob( (blob) => {
    //       const file = new File( [ blob ], "image-without-border.png" );
    //       const dT = new DataTransfer();
    //       dT.items.add( file );
    //         console.log(dT.files);
    //       document.querySelector( "#image-without-border" ).files = dT.files;
    //         // $(".personalization-submit").submit();
    //         // document.querySelector( "#backCapturedVal" ).value = dataUrl;
    //     } );    
    //   // download.setAttribute("href", image);
    //   //        download.click();
    //   //      //downloadPNG();
    //        });
  
   
  var handleSubmit = setInterval(submitFormAll, 100);

async function submitFormAll(){
  if($("#image-with-border").val() != ''){
    clearInterval(handleSubmit);

    var file1 = $('#upload_logo')[0].files[0];
    var file2 = $('#properties_logo')[0].files[0];
    var file3 = $('#image-with-border')[0].files[0];
    var logo_width = $("#logo_width").val();
    var price_new_properties = $(".price-to-be-updated").html();
    price_new_properties = price_new_properties * 100;

    const products = [];

    $('.product_selected_true').each(function(){
        var sel_cart_id = $(this).attr('data_pro_id').replace(/,/g , '');
        var sel_cart_qty = $(this).find('.qty-inner-select-val2').val();

        products.push({
            id: sel_cart_id,
            qty: sel_cart_qty
        });
    });

    // Add products one by one
    for (let i = 0; i < products.length; i++) {

        let formData = new FormData();
        formData.append("id", products[i].id);
        formData.append("quantity", products[i].qty);
        formData.append("properties[custom-orders]", 'true');
        formData.append("properties[logo_width]", logo_width);
        formData.append("properties[_igp]", price_new_properties);
        formData.append("properties[_timestamp]", timestamp);

        if(file1) formData.append("properties[OriginalLogo]", file1);
        if(file2) formData.append("properties[Logo]", file2);
        if(file3) formData.append("properties[ImageBorder]", file3);

        // Debug
        for (let pair of formData.entries()) {
            console.log(pair[0] + ': ', pair[1]);
        }

        await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        });

        if ($("input[name=photo_proof]:checked").val()!="no_photo_proof") {
          let id=$("input[name=photo_proof]:checked").val();
          $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'JSON',
            data: {
              id:id,
              quantity:1,
               properties: {
                _timestamp: timestamp
              }
            },
            success: function(res){
              console.log("success",res);
              $('cart-items-component').load(window.location.href + ' cart-items-component > *');
              // window.location.assign('/cart');
              setTimeout(() => {
                timestamp = Date.now();
              }, 5000);
            },
            error: function(error){
              console.log(error);
            }
          });
        }

        // Prevent 429 rate limit
        await new Promise(r => setTimeout(r, 300));
    }
    $(".main-loader-div-cstm").attr("style","display:none !important");
    console.log("All products added");
    $("cart-drawer-component .header-actions__action").trigger("click");
    $(".cart-drawer__dialog.cart-drawer--empty").removeClass("cart-drawer--empty")
    $('cart-items-component').load(window.location.href + ' cart-items-component > *');
  }
}
}



/********************************* Property marking page start *************************************/
$(".color-variants li:first-child").find('img').css("border", "1px solid rgba(255, 92, 41, 1)");

var get_varid;
  $(".color-variants li").click(function(){
    let get_img = $(this).attr("data-src");
    let var_color = $(this).attr("data-varinat-color");
    $(".color-variants li img").css("border", "none");
    $(this).find('img').css("border", "1px solid rgba(255, 92, 41, 1)");
    $('.selected-color-variants-titel').text(var_color);
    get_varid = $(this).attr("data-variant-id");
    $(".color-variants li span").css('opacity', '.7');
    $(this).find("span").css('opacity', '1');
    // alert(get_varid);
    $(".custom-image-printing-images-jtpl  .main-image").attr('src',get_img);
    $(".prd-details-jtpl").val(get_varid);
    $(".custom-image-printing-radio-box-jtpl").attr("data-var-id", get_varid);
    // if($("#photo_proof").prop('checked',true)){
    //   $("#photo_proof").prop("checked", false);
    // }else {
    //   $("#photo_proof").prop("checked", false);
    // }

    // $('.custom-image-printing-radio-box-jtpl').find('input:checked').each(function(){$(this).prop("checked", false);});
});

$(".custom-image-printing-radio-box-jtpl lable").on('click',function(e){
  e.preventDefault()
  $(this).parent().find('input').prop('checked', true);
  if($("#photo_proof").is(":checked")){
    $(".property-marking-pdp-form-button-jtpl input").val($(".custom-image-printing-radio-box-jtpl").attr("data-var-id")+","+40097049182243);
    var item_checked_lable_1 = $(this).text();
    console.log(item_checked_lable_1);
    $(".property-marking-pdp-form-button-jtpl input").attr('data-line-item', $.trim(item_checked_lable_1));
  }
  // else if($("#no_photo_proof").is(":checked")){
  //   $(".property-marking-pdp-form-button-jtpl input").val($(".custom-image-printing-radio-box-jtpl").attr("data-var-id"));
  //   var item_checked_lable_2 = $(this).parent().find("lable").text();
  //    $(".property-marking-pdp-form-button-jtpl input").attr('data-line-item', item_checked_lable_2);
  // }
  
});

  var DTA_arry_id = [];
  var DTA_arry_qty = [];

$(document).on('click', '.property-marking-pdp-form-button-jtpl #CustomAddToCart', function(e){
  e.preventDefault();
  var item=[];
  // $('.custom-image-printing-radio-box-jtpl input').find('input:checked').each(function(){
var checked_label = $(".prd-details-jtpl").val() || "";
var checked_lable_trim = checked_label.trim();
  console.log("trim data testing : "+checked_lable_trim);
  $(".error_message").html('');
  $('input[name="photo_proof"]:checked').val();
   if($('#upload_logo').val() == ''){
    // alert("Please upload the logo!");
    $(".custom-image-printing-upload-logo-jtpl .err-msg").show()
    // $(".custom-image-printing-upload-logo-jtpl .err-msg").remove();
    // document.querySelector(".custom-image-printing-upload-logo-jtpl").innerHTML+="<span class='err-msg'>Please upload the logo!</span>"
    // $(".error_message").html('Please upload the logo!');
    return false;
  }
  else{
    $(".custom-image-printing-upload-logo-jtpl .err-msg").hide()
  }

  if($('input[name="photo_proof"]:checked').val() == undefined || $('input[name="photo_proof"]:checked').val() == ''){
    alert("Please select the photo proof!!");
    $(".error_message").html('Please select the photo proof!!');
    return false;
  }
    if($('input[name="approve_photo_proof"]:checked').val() == undefined || $('input[name="approve_photo_proof"]:checked').val() == ''){
    // alert("Please tick and approved the Property Marking Project!!");
    $(".approve-checkbox-wrapper .err-msg").remove();
    document.querySelector(".approve-checkbox-wrapper").innerHTML+="<span class='err-msg'>Please tick and approved the Property Marking Project!!</span>"
    return false;
  }

  console.log($('input[name="photo_proof"]:checked').val());
   var ids =  $('input[name="photo_proof"]:checked').val();
  // var ids_no_proof =  $('input[name="no_photo_proof"]:checked').val();
  console.log(ids);
  var html ="";
    if($('input[name="photo_proof"]:checked').val() != "no_photo_proof"){
      html += `<input type="hidden" name="items[1][id]" value='${ids}'/>`;
      html += `<input type="hidden" name="items[1][quantity]" value='1'/>`;
      html += `<input type="hidden" name="items[1][properties][_title]" value='${checked_lable_trim}'/>`;
      // html += `<input type="hidden" name="items[1][properties][_image]" value='${dataURL}'/>`;
      //  item.push({"id":ids_int,"quantity":1, "properties":{ "_title": checked_lable }});
    }
 
  $(".hidden-fields-jtpl").append(html);
 // var productTitle = $('.property-marking-page-title-jtpl').attr('product-title');
     
  // $('select.printing-pricing-jtpl option').each(function() {
  //       // Check if the data-printing-title matches the productTitle
  //       if ($(this).data('data-printing-title') === productTitle) {
  //           printingId = $(this).data('data-printing-id');
  //            alert(printingId);
  //           return false; // Exit the loop once a match is found
  //       }
  //   });

  var selectedPrnting = $('.printing-pricing-jtpl').find(":selected").attr("data-printing-id");
  //alert(selectedPrnting);
  var selectedPrnting = parseInt(selectedPrnting );
  var currntqantity = $('.new-custom-qty__wrapper').find("#product-quantity-input2").val();
  var currntqantity= parseInt(currntqantity );
    //   var currntProductQauntity =  getCookie("currntProductQauntity");
    // var pintingPricesAddon =  getCookie("pintingPricesAddon");
    var ProductPack =  getCookie("ProductPack");
    var currntqantity = currntqantity * ProductPack;
       // currntqantity = currntqantity*2
 uploadImage();
  // delete_cookie('itemsArr');
    $.ajax({
  url: '/cart/add.js',
  type: 'POST',
  dataType: 'JSON',
  data: {
    id: selectedPrnting,
    quantity: currntqantity,
    properties: {
      _timestamp: timestamp
    }
  },
  success: function() {
    console.log("success");
    console.log(selectedPrnting + "=========" + currntqantity);
  },
  error: function(error) {
    console.log(error);
  }
});

  
});

// Info-text hover  
$(".property-marking-info-button").hover(function(){
    $(this).find(".info-text").toggleClass("active-info");
});

// Thumbnail image change
$('.property-marking-page-gallery-thumbnail-items img').on('click', function(){
    var thumb_src = $(this).attr('src');
    $('.property-marking-page-gallery-main-image-jtpl img').attr('src', thumb_src);
});

$('.uploaded-image-delete-button').on('click', function() {     
      $('#upload_logo').val('');
     $('.uploaded-image-container').css('display','none');
     $('div#image-upload-logo').empty();
});



       // $('#upload_logo').on('change', function() {
         
       //      var size = 
       //         (this.files[0].size / 1024 / 1024).toFixed(2);
         
       //      if (size > 4 || size < 2) {
       //          alert("File must be between the size of 2-4 MB");
       //      } else {
       //          $("#output").html('<b>' +
       //             'This file size is: ' + size + " MB" + '</b>');
       //      }
       //  });


        
        // Filevalidation = () => {
        //     const fi = document.getElementById('upload_logo');
        //     // Check if any file is selected.
        //     if (fi.files.length > 0) {
        //         for (const i = 0; i <= fi.files.length - 1; i++) {
 
        //             const fsize = fi.files.item(i).size;
        //             const file = Math.round((fsize / 1024));
        //             // The size of the file.
        //             if (file >= 4096) {
        //                 alert(
        // "File too Big, please select a file less than 4mb");
        //             } else if (file < 2048) {
        //                 alert(
        // "File too small, please select a file greater than 2mb");
        //             } else {
        //                 document.getElementById('size').innerHTML = 
        //                   '<b>'+ file + '</b> KB';
        //             }
        //         }
        //     }
        // }

   
 /********************************* Property marking page end *************************************/


 